import {environment} from './../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {BehaviorSubject, Observable, throwError} from 'rxjs';

import {catchError, filter, share, switchMap, take} from 'rxjs/operators';
import {Router} from '@angular/router';
import {Store} from "@ngxs/store";
import {AuthenticationService} from "../../service/auth.service";
import {LogoutAction} from "../../actions/auth.actions";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private store: Store,
    private modalService: NgbModal
  ) {
  }

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private otpUrl = environment.securityUrl + '/otp'

  private blacklist: object = [
    /\/recover_password/,
    /\/public\/countries/
  ];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // exempt some paths from authentication
    if (this.blacklistCheckup(request.url)) {
      return next.handle(request);
    }

    // Do request and catch errors
    // Add auth token
    return next.handle(this.addToken(request)).pipe(
      catchError(err => {
        if (err.status === 403) {
          if (this.modalService.hasOpenModals()) {
            this.modalService.dismissAll()
          }
          //this.router.navigate(['/common/errors/403']);
          this.router.navigate(['/login']);
        }
        console.log("ERROR CODE="+err.status)
        console.log("err.status === 401 =>", err.status === 401)
        // check for 401 error
        if (err.status === 401) {

          console.log("Try to refresh token");

          // Don't refresh token for login and renew endpoints
          if (
            request.url.includes('/renew') ||
            request.url.includes('/auth')
          ) {
            // We do another check to see if refresh token failed
            // In this case we want to logout user and refresh the page
            if (request.url.includes('/renew')) {
              // auto logout if 401 response returned from api
              this.logout()
            }
            console.log("throwError", err);
            return throwError(err);
          }

          return this.refreshToken(request, next)
        }

        return throwError(err);
      })
    );
  }

  private addToken(request: HttpRequest<any>) {
    // add authorization header with jwt token if available
    const tokens = this.authenticationService.getTokens();

    if (
        (request.url.includes(environment.apiBaseUrl)
          || request.url.includes(this.otpUrl)
          || request.url.includes('/recover_password/portal')
        )
      && tokens
      && tokens.accessToken
    ) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${tokens.accessToken}`
        }
      });
    }

    return request
  }


  private refreshToken(request: HttpRequest<any>, next: HttpHandler) {

    // Refresh token
    if (!this.isRefreshing) {

      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const tokens = this.authenticationService.getTokens();

      return this.authenticationService.refreshToken(tokens.refreshToken).pipe(
        share(),
        switchMap((data: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(data.newAccessToken);
          return next.handle(this.addToken(request));
        }),
        catchError(err => {
          this.isRefreshing = false;
          this.logout()
          return throwError(err);
        })
      );

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => {
          return token != null
        }),
        take(1),
        switchMap(jwt => {
          this.isRefreshing = false;
          return next.handle(this.addToken(request));
        })
      );
    }
  }

  private logout() {
    //this.authenticationService.logout();
    //this.router.navigate(['/account/login']);
    if (this.modalService.hasOpenModals()) {
      this.modalService.dismissAll()
    }
    this.store.dispatch(new LogoutAction());
  }

  blacklistCheckup($url: string): boolean {
    let returnValue = false;

    for (const i of Object.keys(this.blacklist)) {
      if (this.blacklist[i].exec($url) !== null) {
        returnValue = true;
        break;
      }
    }

    return returnValue;
  }
}
